import { useContext } from "react";

import { constantsData } from "@/data";
import { ThemeProviderContext } from "@/providers/theme";

export const useTheme = () => {
    const context = useContext(ThemeProviderContext);

    if (context === undefined) throw new Error(constantsData.msgs.providers.theme);

    return context;
};
